const initalState = {
    activationLoading: false,
    activationError:null,
    activationSuccess: null
  }
  
  export const activation = (state = initalState, action) => {
    switch (action.type) {
      case "ACTIVATION_REQUEST": {
        return { ...state, loading: true,activationError:null,activationSuccess: null }
      }
      case "ACTIVATION_SUCCESS": {
        return { ...state, activationError:null,loading: false,activationSuccess: action.payload}
      }
      case "ACTIVATION_FAILURE": {
        return { ...state, loading: false,activationError:action.payload, activationSuccess: null}
      }
      default: {
        return state
      }
    }
  }